import { ParameterLevel, Parameters, userInfo as UserInfo } from '@web/common';
import { z } from 'zod';

export function parseGoalValue(userInfo: z.input<typeof UserInfo>) {
  if (userInfo.goal) {
    let parsedValue: number | ParameterLevel;
    switch (userInfo.goal.parameter) {
      case Parameters.BODY_WEIGHT:
      case Parameters.FAT_MASS:
      case Parameters.FAT_PERCENTAGE:
      case Parameters.MUSCLE_MASS:
      case Parameters.MUSCLE_PERCENTAGE:
      case Parameters.BODY_MASS_INDEX:
      case Parameters.BLOOD_PRESSURE:
      case Parameters.BLOOD_PRESSURE_SYSTOLIC:
      case Parameters.BLOOD_PRESSURE_DIASTOLIC:
      case Parameters.PULSE: {
        parsedValue = parseInt(userInfo.goal.value);
        break;
      }
      case Parameters.CARDIO_FITNESS:
      case Parameters.CARDIOVASCULAR_RISK:
      case Parameters.PHYSICAL_FITNESS:
      case Parameters.HEART_STRENGTH:
      case Parameters.STRESS_LEVEL: {
        parsedValue = userInfo.goal.value as ParameterLevel;
        break;
      }
    }
    return {
      name: userInfo.goal.name,
      parameter: userInfo.goal.parameter,
      targetValue: parsedValue,
    };
  }
  return undefined;
}
